import { Box, styled } from '@mui/material';

export const CancelTargetInfoRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

/** 취소 대상 원 품의 한 줄 — 레거시 조회 폼 info-box 와 같은 바탕·외곽선 */
export const CancelTargetBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 12px;
  border: 1px solid var(--dk-line, #e7e9ec);
  border-radius: 4px;
  background-color: var(--dk-bg-subtle, #f9fafb);
  font-family: Pretendard, sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: var(--dk-text, #1d2025);
`;

export const CancelTargetSubject = styled('span')`
  min-width: 0;
  word-break: break-word;
`;

export const CancelTargetDate = styled('span')`
  flex-shrink: 0;
  color: var(--dk-text-strong, #4d5157);
`;

/** 원문 열람 링크(새 탭) */
export const CancelTargetLinkAnchor = styled('a')`
  align-self: flex-start;
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: var(--dk-text, #1d2025);
  text-decoration: underline;

  &:hover {
    color: var(--dk-accent, #0066cc);
  }

  & > svg {
    margin-left: 4px;
    vertical-align: middle;
    color: var(--dk-text-secondary, #888d96);
  }
`;
